import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from '../Guards/admin.guard';
import { NonAdminGuard } from '../Guards/non-admin.guard';
import { UserRoleGuard } from '../Guards/user-role.guard';
import { PageNotFoundComponent } from '../pages/page-not-found/page-not-found.component';
import { ShowQrComponent } from '../pages/show-qr/show-qr.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../modules/feature/dashboard.module').then(m => m.DashboardModule),
    canActivate: [NonAdminGuard]
  },
  {
    path: 'customers',
    loadChildren: () => import('../modules/feature/customers.module').then(m => m.CustomersModule),
    canActivate: [NonAdminGuard,UserRoleGuard]
  },
  { path: 'device/:id', redirectTo: 'customers/printer/:id'},
  {
    path: 'substrates',
    loadChildren: () => import('../modules/feature/substrates.module').then(m => m.SubstratesModule),
    canActivate: [NonAdminGuard,UserRoleGuard]
  },
  {
    path: 'cases',
    loadChildren: () => import('../modules/feature/cases.module').then(m => m.CasesModule),
    canActivate: [NonAdminGuard,UserRoleGuard]
  },
  {
    path: 'service-plans',
    loadChildren: () => import('../modules/feature/service-plans.module').then(m => m.ServicePlansModule),
    canActivate: [NonAdminGuard]
  },
  // {
  //   path: 'case',
  //   loadChildren: () => import('../modules/feature/caseDetail.module').then(m => m.CasesDetailModule),
  //   canActivate: [NonAdminGuard]
  // },
  {
    path: 'coverage_area',
    loadChildren: () => import('../modules/feature/configuration.module').then(m => m.ConfigurationModule),
    canActivate: [NonAdminGuard,UserRoleGuard]
  },
  {
    path: 'calendar',
    loadChildren: () => import('../modules/feature/calendar.module').then(m => m.CalendarModule),
    canActivate: [NonAdminGuard,UserRoleGuard]
  },
  {
    path: 'qrcode',
    component: ShowQrComponent,
    canActivate: [NonAdminGuard]
  },
  {
    path: 'admins',
    loadChildren: () => import('../modules/feature/printos-admin.module').then(m => m.PrintosAdminModule),
    canActivate: [AdminGuard]
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    canActivate: [NonAdminGuard]
  },
  {
    path: '**',
    redirectTo: 'page-not-found'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
